export default __webpack_public_path__ + "static/media/calendar.dfdf0bb5.svg";